import { observer } from 'mobx-react-lite'
import { Navigate } from 'react-router-dom'
import { SmsTemplatesShadcnComponent } from 'app/components/sms-templates/SmsTemplatesShadcnComponent'
import { useSmsTemplates } from 'app/components/sms-templates/useSmsTemplates'
import { useTemplateTabs } from 'app/components/templates/useTemplateTabs'

// The SMS tab of the templates hub (/settings/templates). Future template
// types (task templates, ...) are sibling routes sharing the same header/tabs.
// observer() because useSmsTemplates derives the template list from the
// MobX store during this component's render.
const SettingsTemplatesSms = observer(function SettingsTemplatesSms() {
  const { smsEnabled } = useTemplateTabs()
  const props = useSmsTemplates()
  // Deep links stay honest: a workspace with no Inbox location has no SMS tab,
  // so send it to the tab it does have.
  if (smsEnabled === false) return <Navigate to="/settings/templates/tasks" replace />
  return <SmsTemplatesShadcnComponent {...props} />
})

export default SettingsTemplatesSms
